"use client";

import { useEffect } from "react";
const DeviceIdLogic = () => {
  useEffect(() => {
    window.addEventListener("beforeunload", () => {
      const startTime = localStorage.getItem("startTime");
      const difference = Date.now() - Number(startTime || 0);
      const minutesDifference = Math.floor(difference / 1000 / 60);
      void (async () => {
        const mixpanelV1Client = (await import("services/mixpanel")).mixpanelV1Client;
        mixpanelV1Client.SESSION_CLOSED({
          length: minutesDifference
        });
      })();
      localStorage.removeItem("startsession");
    });
  }, []);
  useEffect(() => {
    const startSession = localStorage.getItem("startsession");
    if (!startSession) {
      localStorage.setItem("startsession", "true");
      localStorage.setItem("startTime", JSON.stringify(Date.now()));
    }
  }, []);
  return null;
};
export default DeviceIdLogic;